import { keyBy } from "lodash";
import { Country } from "../../models/Address";
import { DisplayValueMap } from "../../models/Model";

export const DefaultCountry: Country = {
  countryID: 0,
  countryCode: "TH",
  titleEN: "Thailand",
  titleLocal: "ประเทศไทย",
  countryCallingCode: "+66",
};

export const CountryListConst = [
  {
    name: "Thailand",
    alpha2Code: "TH",
    callingCodes: ["66"],
    languages: ["th"],
  },
  {
    name: "Afghanistan",
    alpha2Code: "AF",
    callingCodes: ["93"],
    languages: ["ps", "uz", "tk"],
  },
  {
    name: "Åland Islands",
    alpha2Code: "AX",
    callingCodes: ["358"],
    languages: ["sv"],
  },
  {
    name: "Albania",
    alpha2Code: "AL",
    callingCodes: ["355"],
    languages: ["sq"],
  },
  {
    name: "Algeria",
    alpha2Code: "DZ",
    callingCodes: ["213"],
    languages: ["ar"],
  },
  {
    name: "American Samoa",
    alpha2Code: "AS",
    callingCodes: ["1684"],
    languages: ["en", "sm"],
  },
  {
    name: "Andorra",
    alpha2Code: "AD",
    callingCodes: ["376"],
    languages: ["ca"],
  },
  {
    name: "Angola",
    alpha2Code: "AO",
    callingCodes: ["244"],
    languages: ["pt"],
  },
  {
    name: "Anguilla",
    alpha2Code: "AI",
    callingCodes: ["1264"],
    languages: ["en"],
  },
  {
    name: "Antarctica",
    alpha2Code: "AQ",
    callingCodes: ["672"],
    languages: [],
  },
  {
    name: "Antigua and Barbuda",
    alpha2Code: "AG",
    callingCodes: ["1268"],
    languages: ["en"],
  },
  {
    name: "Argentina",
    alpha2Code: "AR",
    callingCodes: ["54"],
    languages: ["es", "gn"],
  },
  {
    name: "Armenia",
    alpha2Code: "AM",
    callingCodes: ["374"],
    languages: ["hy", "ru"],
  },
  {
    name: "Aruba",
    alpha2Code: "AW",
    callingCodes: ["297"],
    languages: ["nl", "pa"],
  },
  {
    name: "Australia",
    alpha2Code: "AU",
    callingCodes: ["61"],
    languages: ["en"],
  },
  {
    name: "Austria",
    alpha2Code: "AT",
    callingCodes: ["43"],
    languages: ["de"],
  },
  {
    name: "Azerbaijan",
    alpha2Code: "AZ",
    callingCodes: ["994"],
    languages: ["az"],
  },
  {
    name: "Bahamas",
    alpha2Code: "BS",
    callingCodes: ["1242"],
    languages: ["en"],
  },
  {
    name: "Bahrain",
    alpha2Code: "BH",
    callingCodes: ["973"],
    languages: ["ar"],
  },
  {
    name: "Bangladesh",
    alpha2Code: "BD",
    callingCodes: ["880"],
    languages: ["bn"],
  },
  {
    name: "Barbados",
    alpha2Code: "BB",
    callingCodes: ["1246"],
    languages: ["en"],
  },
  {
    name: "Belarus",
    alpha2Code: "BY",
    callingCodes: ["375"],
    languages: ["be", "ru"],
  },
  {
    name: "Belgium",
    alpha2Code: "BE",
    callingCodes: ["32"],
    languages: ["nl", "fr", "de"],
  },
  {
    name: "Belize",
    alpha2Code: "BZ",
    callingCodes: ["501"],
    languages: ["en", "es"],
  },
  {
    name: "Benin",
    alpha2Code: "BJ",
    callingCodes: ["229"],
    languages: ["fr"],
  },
  {
    name: "Bermuda",
    alpha2Code: "BM",
    callingCodes: ["1441"],
    languages: ["en"],
  },
  {
    name: "Bhutan",
    alpha2Code: "BT",
    callingCodes: ["975"],
    languages: ["dz"],
  },
  {
    name: "Bolivia (Plurinational State of)",
    alpha2Code: "BO",
    callingCodes: ["591"],
    languages: ["es", "ay", "qu"],
  },
  {
    name: "Bonaire, Sint Eustatius and Saba",
    alpha2Code: "BQ",
    callingCodes: ["5997"],
    languages: ["nl"],
  },
  {
    name: "Bosnia and Herzegovina",
    alpha2Code: "BA",
    callingCodes: ["387"],
    languages: ["bs", "hr", "sr"],
  },
  {
    name: "Botswana",
    alpha2Code: "BW",
    callingCodes: ["267"],
    languages: ["en", "tn"],
  },
  {
    name: "Bouvet Island",
    alpha2Code: "BV",
    callingCodes: [""],
    languages: ["no", "nb", "nn"],
  },
  {
    name: "Brazil",
    alpha2Code: "BR",
    callingCodes: ["55"],
    languages: ["pt"],
  },
  {
    name: "British Indian Ocean Territory",
    alpha2Code: "IO",
    callingCodes: ["246"],
    languages: ["en"],
  },
  {
    name: "United States Minor Outlying Islands",
    alpha2Code: "UM",
    callingCodes: [""],
    languages: ["en"],
  },
  {
    name: "Virgin Islands (British)",
    alpha2Code: "VG",
    callingCodes: ["1284"],
    languages: ["en"],
  },
  {
    name: "Virgin Islands (U.S.)",
    alpha2Code: "VI",
    callingCodes: ["1 340"],
    languages: ["en"],
  },
  {
    name: "Brunei Darussalam",
    alpha2Code: "BN",
    callingCodes: ["673"],
    languages: ["ms"],
  },
  {
    name: "Bulgaria",
    alpha2Code: "BG",
    callingCodes: ["359"],
    languages: ["bg"],
  },
  {
    name: "Burkina Faso",
    alpha2Code: "BF",
    callingCodes: ["226"],
    languages: ["fr", "ff"],
  },
  {
    name: "Burundi",
    alpha2Code: "BI",
    callingCodes: ["257"],
    languages: ["fr", "rn"],
  },
  {
    name: "Cambodia",
    alpha2Code: "KH",
    callingCodes: ["855"],
    languages: ["km"],
  },
  {
    name: "Cameroon",
    alpha2Code: "CM",
    callingCodes: ["237"],
    languages: ["en", "fr"],
  },
  {
    name: "Canada",
    alpha2Code: "CA",
    callingCodes: ["1"],
    languages: ["en", "fr"],
  },
  {
    name: "Cabo Verde",
    alpha2Code: "CV",
    callingCodes: ["238"],
    languages: ["pt"],
  },
  {
    name: "Cayman Islands",
    alpha2Code: "KY",
    callingCodes: ["1345"],
    languages: ["en"],
  },
  {
    name: "Central African Republic",
    alpha2Code: "CF",
    callingCodes: ["236"],
    languages: ["fr", "sg"],
  },
  {
    name: "Chad",
    alpha2Code: "TD",
    callingCodes: ["235"],
    languages: ["fr", "ar"],
  },
  {
    name: "Chile",
    alpha2Code: "CL",
    callingCodes: ["56"],
    languages: ["es"],
  },
  {
    name: "China",
    alpha2Code: "CN",
    callingCodes: ["86"],
    languages: ["zh"],
  },
  {
    name: "Christmas Island",
    alpha2Code: "CX",
    callingCodes: ["61"],
    languages: ["en"],
  },
  {
    name: "Cocos (Keeling) Islands",
    alpha2Code: "CC",
    callingCodes: ["61"],
    languages: ["en"],
  },
  {
    name: "Colombia",
    alpha2Code: "CO",
    callingCodes: ["57"],
    languages: ["es"],
  },
  {
    name: "Comoros",
    alpha2Code: "KM",
    callingCodes: ["269"],
    languages: ["ar", "fr"],
  },
  {
    name: "Congo",
    alpha2Code: "CG",
    callingCodes: ["242"],
    languages: ["fr", "ln"],
  },
  {
    name: "Congo (Democratic Republic of the)",
    alpha2Code: "CD",
    callingCodes: ["243"],
    languages: ["fr", "ln", "kg", "sw", "lu"],
  },
  {
    name: "Cook Islands",
    alpha2Code: "CK",
    callingCodes: ["682"],
    languages: ["en"],
  },
  {
    name: "Costa Rica",
    alpha2Code: "CR",
    callingCodes: ["506"],
    languages: ["es"],
  },
  {
    name: "Croatia",
    alpha2Code: "HR",
    callingCodes: ["385"],
    languages: ["hr"],
  },
  {
    name: "Cuba",
    alpha2Code: "CU",
    callingCodes: ["53"],
    languages: ["es"],
  },
  {
    name: "Curaçao",
    alpha2Code: "CW",
    callingCodes: ["599"],
    languages: ["nl", "pa", "en"],
  },
  {
    name: "Cyprus",
    alpha2Code: "CY",
    callingCodes: ["357"],
    languages: ["el", "tr", "hy"],
  },
  {
    name: "Czech Republic",
    alpha2Code: "CZ",
    callingCodes: ["420"],
    languages: ["cs", "sk"],
  },
  {
    name: "Denmark",
    alpha2Code: "DK",
    callingCodes: ["45"],
    languages: ["da"],
  },
  {
    name: "Djibouti",
    alpha2Code: "DJ",
    callingCodes: ["253"],
    languages: ["fr", "ar"],
  },
  {
    name: "Dominica",
    alpha2Code: "DM",
    callingCodes: ["1767"],
    languages: ["en"],
  },
  {
    name: "Dominican Republic",
    alpha2Code: "DO",
    callingCodes: ["1809", "1829", "1849"],
    languages: ["es"],
  },
  {
    name: "Ecuador",
    alpha2Code: "EC",
    callingCodes: ["593"],
    languages: ["es"],
  },
  {
    name: "Egypt",
    alpha2Code: "EG",
    callingCodes: ["20"],
    languages: ["ar"],
  },
  {
    name: "El Salvador",
    alpha2Code: "SV",
    callingCodes: ["503"],
    languages: ["es"],
  },
  {
    name: "Equatorial Guinea",
    alpha2Code: "GQ",
    callingCodes: ["240"],
    languages: ["es", "fr"],
  },
  {
    name: "Eritrea",
    alpha2Code: "ER",
    callingCodes: ["291"],
    languages: ["ti", "ar", "en"],
  },
  {
    name: "Estonia",
    alpha2Code: "EE",
    callingCodes: ["372"],
    languages: ["et"],
  },
  {
    name: "Ethiopia",
    alpha2Code: "ET",
    callingCodes: ["251"],
    languages: ["am"],
  },
  {
    name: "Falkland Islands (Malvinas)",
    alpha2Code: "FK",
    callingCodes: ["500"],
    languages: ["en"],
  },
  {
    name: "Faroe Islands",
    alpha2Code: "FO",
    callingCodes: ["298"],
    languages: ["fo"],
  },
  {
    name: "Fiji",
    alpha2Code: "FJ",
    callingCodes: ["679"],
    languages: ["en", "fj", "hi", "ur"],
  },
  {
    name: "Finland",
    alpha2Code: "FI",
    callingCodes: ["358"],
    languages: ["fi", "sv"],
  },
  {
    name: "France",
    alpha2Code: "FR",
    callingCodes: ["33"],
    languages: ["fr"],
  },
  {
    name: "French Guiana",
    alpha2Code: "GF",
    callingCodes: ["594"],
    languages: ["fr"],
  },
  {
    name: "French Polynesia",
    alpha2Code: "PF",
    callingCodes: ["689"],
    languages: ["fr"],
  },
  {
    name: "French Southern Territories",
    alpha2Code: "TF",
    callingCodes: [""],
    languages: ["fr"],
  },
  {
    name: "Gabon",
    alpha2Code: "GA",
    callingCodes: ["241"],
    languages: ["fr"],
  },
  {
    name: "Gambia",
    alpha2Code: "GM",
    callingCodes: ["220"],
    languages: ["en"],
  },
  {
    name: "Georgia",
    alpha2Code: "GE",
    callingCodes: ["995"],
    languages: ["ka"],
  },
  {
    name: "Germany",
    alpha2Code: "DE",
    callingCodes: ["49"],
    languages: ["de"],
  },
  {
    name: "Ghana",
    alpha2Code: "GH",
    callingCodes: ["233"],
    languages: ["en"],
  },
  {
    name: "Gibraltar",
    alpha2Code: "GI",
    callingCodes: ["350"],
    languages: ["en"],
  },
  {
    name: "Greece",
    alpha2Code: "GR",
    callingCodes: ["30"],
    languages: ["el"],
  },
  {
    name: "Greenland",
    alpha2Code: "GL",
    callingCodes: ["299"],
    languages: ["kl"],
  },
  {
    name: "Grenada",
    alpha2Code: "GD",
    callingCodes: ["1473"],
    languages: ["en"],
  },
  {
    name: "Guadeloupe",
    alpha2Code: "GP",
    callingCodes: ["590"],
    languages: ["fr"],
  },
  {
    name: "Guam",
    alpha2Code: "GU",
    callingCodes: ["1671"],
    languages: ["en", "ch", "es"],
  },
  {
    name: "Guatemala",
    alpha2Code: "GT",
    callingCodes: ["502"],
    languages: ["es"],
  },
  {
    name: "Guernsey",
    alpha2Code: "GG",
    callingCodes: ["44"],
    languages: ["en", "fr"],
  },
  {
    name: "Guinea",
    alpha2Code: "GN",
    callingCodes: ["224"],
    languages: ["fr", "ff"],
  },
  {
    name: "Guinea-Bissau",
    alpha2Code: "GW",
    callingCodes: ["245"],
    languages: ["pt"],
  },
  {
    name: "Guyana",
    alpha2Code: "GY",
    callingCodes: ["592"],
    languages: ["en"],
  },
  {
    name: "Haiti",
    alpha2Code: "HT",
    callingCodes: ["509"],
    languages: ["fr", "ht"],
  },
  {
    name: "Heard Island and McDonald Islands",
    alpha2Code: "HM",
    callingCodes: [""],
    languages: ["en"],
  },
  {
    name: "Holy See",
    alpha2Code: "VA",
    callingCodes: ["379"],
    languages: ["it", "la"],
  },
  {
    name: "Honduras",
    alpha2Code: "HN",
    callingCodes: ["504"],
    languages: ["es"],
  },
  {
    name: "Hong Kong",
    alpha2Code: "HK",
    callingCodes: ["852"],
    languages: ["zh", "en"],
  },
  {
    name: "Hungary",
    alpha2Code: "HU",
    callingCodes: ["36"],
    languages: ["hu"],
  },
  {
    name: "Iceland",
    alpha2Code: "IS",
    callingCodes: ["354"],
    languages: ["is"],
  },
  {
    name: "India",
    alpha2Code: "IN",
    callingCodes: ["91"],
    languages: ["hi", "en"],
  },
  {
    name: "Indonesia",
    alpha2Code: "ID",
    callingCodes: ["62"],
    languages: ["id"],
  },
  {
    name: "Côte d'Ivoire",
    alpha2Code: "CI",
    callingCodes: ["225"],
    languages: ["fr"],
  },
  {
    name: "Iran (Islamic Republic of)",
    alpha2Code: "IR",
    callingCodes: ["98"],
    languages: ["fa"],
  },
  {
    name: "Iraq",
    alpha2Code: "IQ",
    callingCodes: ["964"],
    languages: ["ar", "ku"],
  },
  {
    name: "Ireland",
    alpha2Code: "IE",
    callingCodes: ["353"],
    languages: ["ga", "en"],
  },
  {
    name: "Isle of Man",
    alpha2Code: "IM",
    callingCodes: ["44"],
    languages: ["en", "gv"],
  },
  {
    name: "Israel",
    alpha2Code: "IL",
    callingCodes: ["972"],
    languages: ["he", "ar"],
  },
  {
    name: "Italy",
    alpha2Code: "IT",
    callingCodes: ["39"],
    languages: ["it"],
  },
  {
    name: "Jamaica",
    alpha2Code: "JM",
    callingCodes: ["1876"],
    languages: ["en"],
  },
  {
    name: "Japan",
    alpha2Code: "JP",
    callingCodes: ["81"],
    languages: ["ja"],
  },
  {
    name: "Jersey",
    alpha2Code: "JE",
    callingCodes: ["44"],
    languages: ["en", "fr"],
  },
  {
    name: "Jordan",
    alpha2Code: "JO",
    callingCodes: ["962"],
    languages: ["ar"],
  },
  {
    name: "Kazakhstan",
    alpha2Code: "KZ",
    callingCodes: ["76", "77"],
    languages: ["kk", "ru"],
  },
  {
    name: "Kenya",
    alpha2Code: "KE",
    callingCodes: ["254"],
    languages: ["en", "sw"],
  },
  {
    name: "Kiribati",
    alpha2Code: "KI",
    callingCodes: ["686"],
    languages: ["en"],
  },
  {
    name: "Kuwait",
    alpha2Code: "KW",
    callingCodes: ["965"],
    languages: ["ar"],
  },
  {
    name: "Kyrgyzstan",
    alpha2Code: "KG",
    callingCodes: ["996"],
    languages: ["ky", "ru"],
  },
  {
    name: "Lao People's Democratic Republic",
    alpha2Code: "LA",
    callingCodes: ["856"],
    languages: ["lo"],
  },
  {
    name: "Latvia",
    alpha2Code: "LV",
    callingCodes: ["371"],
    languages: ["lv"],
  },
  {
    name: "Lebanon",
    alpha2Code: "LB",
    callingCodes: ["961"],
    languages: ["ar", "fr"],
  },
  {
    name: "Lesotho",
    alpha2Code: "LS",
    callingCodes: ["266"],
    languages: ["en", "st"],
  },
  {
    name: "Liberia",
    alpha2Code: "LR",
    callingCodes: ["231"],
    languages: ["en"],
  },
  {
    name: "Libya",
    alpha2Code: "LY",
    callingCodes: ["218"],
    languages: ["ar"],
  },
  {
    name: "Liechtenstein",
    alpha2Code: "LI",
    callingCodes: ["423"],
    languages: ["de"],
  },
  {
    name: "Lithuania",
    alpha2Code: "LT",
    callingCodes: ["370"],
    languages: ["lt"],
  },
  {
    name: "Luxembourg",
    alpha2Code: "LU",
    callingCodes: ["352"],
    languages: ["fr", "de", "lb"],
  },
  {
    name: "Macao",
    alpha2Code: "MO",
    callingCodes: ["853"],
    languages: ["zh", "pt"],
  },
  {
    name: "Macedonia (the former Yugoslav Republic of)",
    alpha2Code: "MK",
    callingCodes: ["389"],
    languages: ["mk"],
  },
  {
    name: "Madagascar",
    alpha2Code: "MG",
    callingCodes: ["261"],
    languages: ["fr", "mg"],
  },
  {
    name: "Malawi",
    alpha2Code: "MW",
    callingCodes: ["265"],
    languages: ["en", "ny"],
  },
  {
    name: "Malaysia",
    alpha2Code: "MY",
    callingCodes: ["60"],
    languages: ["ms"],
  },
  {
    name: "Maldives",
    alpha2Code: "MV",
    callingCodes: ["960"],
    languages: ["dv"],
  },
  {
    name: "Mali",
    alpha2Code: "ML",
    callingCodes: ["223"],
    languages: ["fr"],
  },
  {
    name: "Malta",
    alpha2Code: "MT",
    callingCodes: ["356"],
    languages: ["mt", "en"],
  },
  {
    name: "Marshall Islands",
    alpha2Code: "MH",
    callingCodes: ["692"],
    languages: ["en", "mh"],
  },
  {
    name: "Martinique",
    alpha2Code: "MQ",
    callingCodes: ["596"],
    languages: ["fr"],
  },
  {
    name: "Mauritania",
    alpha2Code: "MR",
    callingCodes: ["222"],
    languages: ["ar"],
  },
  {
    name: "Mauritius",
    alpha2Code: "MU",
    callingCodes: ["230"],
    languages: ["en"],
  },
  {
    name: "Mayotte",
    alpha2Code: "YT",
    callingCodes: ["262"],
    languages: ["fr"],
  },
  {
    name: "Mexico",
    alpha2Code: "MX",
    callingCodes: ["52"],
    languages: ["es"],
  },
  {
    name: "Micronesia (Federated States of)",
    alpha2Code: "FM",
    callingCodes: ["691"],
    languages: ["en"],
  },
  {
    name: "Moldova (Republic of)",
    alpha2Code: "MD",
    callingCodes: ["373"],
    languages: ["ro"],
  },
  {
    name: "Monaco",
    alpha2Code: "MC",
    callingCodes: ["377"],
    languages: ["fr"],
  },
  {
    name: "Mongolia",
    alpha2Code: "MN",
    callingCodes: ["976"],
    languages: ["mn"],
  },
  {
    name: "Montenegro",
    alpha2Code: "ME",
    callingCodes: ["382"],
    languages: ["sr", "bs", "sq", "hr"],
  },
  {
    name: "Montserrat",
    alpha2Code: "MS",
    callingCodes: ["1664"],
    languages: ["en"],
  },
  {
    name: "Morocco",
    alpha2Code: "MA",
    callingCodes: ["212"],
    languages: ["ar"],
  },
  {
    name: "Mozambique",
    alpha2Code: "MZ",
    callingCodes: ["258"],
    languages: ["pt"],
  },
  {
    name: "Myanmar",
    alpha2Code: "MM",
    callingCodes: ["95"],
    languages: ["my"],
  },
  {
    name: "Namibia",
    alpha2Code: "NA",
    callingCodes: ["264"],
    languages: ["en", "af"],
  },
  {
    name: "Nauru",
    alpha2Code: "NR",
    callingCodes: ["674"],
    languages: ["en", "na"],
  },
  {
    name: "Nepal",
    alpha2Code: "NP",
    callingCodes: ["977"],
    languages: ["ne"],
  },
  {
    name: "Netherlands",
    alpha2Code: "NL",
    callingCodes: ["31"],
    languages: ["nl"],
  },
  {
    name: "New Caledonia",
    alpha2Code: "NC",
    callingCodes: ["687"],
    languages: ["fr"],
  },
  {
    name: "New Zealand",
    alpha2Code: "NZ",
    callingCodes: ["64"],
    languages: ["en", "mi"],
  },
  {
    name: "Nicaragua",
    alpha2Code: "NI",
    callingCodes: ["505"],
    languages: ["es"],
  },
  {
    name: "Niger",
    alpha2Code: "NE",
    callingCodes: ["227"],
    languages: ["fr"],
  },
  {
    name: "Nigeria",
    alpha2Code: "NG",
    callingCodes: ["234"],
    languages: ["en"],
  },
  {
    name: "Niue",
    alpha2Code: "NU",
    callingCodes: ["683"],
    languages: ["en"],
  },
  {
    name: "Norfolk Island",
    alpha2Code: "NF",
    callingCodes: ["672"],
    languages: ["en"],
  },
  {
    name: "Korea (Democratic People's Republic of)",
    alpha2Code: "KP",
    callingCodes: ["850"],
    languages: ["ko"],
  },
  {
    name: "Northern Mariana Islands",
    alpha2Code: "MP",
    callingCodes: ["1670"],
    languages: ["en", "ch"],
  },
  {
    name: "Norway",
    alpha2Code: "NO",
    callingCodes: ["47"],
    languages: ["no", "nb", "nn"],
  },
  {
    name: "Oman",
    alpha2Code: "OM",
    callingCodes: ["968"],
    languages: ["ar"],
  },
  {
    name: "Pakistan",
    alpha2Code: "PK",
    callingCodes: ["92"],
    languages: ["en", "ur"],
  },
  {
    name: "Palau",
    alpha2Code: "PW",
    callingCodes: ["680"],
    languages: ["en"],
  },
  {
    name: "Palestine, State of",
    alpha2Code: "PS",
    callingCodes: ["970"],
    languages: ["ar"],
  },
  {
    name: "Panama",
    alpha2Code: "PA",
    callingCodes: ["507"],
    languages: ["es"],
  },
  {
    name: "Papua New Guinea",
    alpha2Code: "PG",
    callingCodes: ["675"],
    languages: ["en"],
  },
  {
    name: "Paraguay",
    alpha2Code: "PY",
    callingCodes: ["595"],
    languages: ["es", "gn"],
  },
  {
    name: "Peru",
    alpha2Code: "PE",
    callingCodes: ["51"],
    languages: ["es"],
  },
  {
    name: "Philippines",
    alpha2Code: "PH",
    callingCodes: ["63"],
    languages: ["en"],
  },
  {
    name: "Pitcairn",
    alpha2Code: "PN",
    callingCodes: ["64"],
    languages: ["en"],
  },
  {
    name: "Poland",
    alpha2Code: "PL",
    callingCodes: ["48"],
    languages: ["pl"],
  },
  {
    name: "Portugal",
    alpha2Code: "PT",
    callingCodes: ["351"],
    languages: ["pt"],
  },
  {
    name: "Puerto Rico",
    alpha2Code: "PR",
    callingCodes: ["1787", "1939"],
    languages: ["es", "en"],
  },
  {
    name: "Qatar",
    alpha2Code: "QA",
    callingCodes: ["974"],
    languages: ["ar"],
  },
  {
    name: "Republic of Kosovo",
    alpha2Code: "XK",
    callingCodes: ["383"],
    languages: ["sq", "sr"],
  },
  {
    name: "Réunion",
    alpha2Code: "RE",
    callingCodes: ["262"],
    languages: ["fr"],
  },
  {
    name: "Romania",
    alpha2Code: "RO",
    callingCodes: ["40"],
    languages: ["ro"],
  },
  {
    name: "Russian Federation",
    alpha2Code: "RU",
    callingCodes: ["7"],
    languages: ["ru"],
  },
  {
    name: "Rwanda",
    alpha2Code: "RW",
    callingCodes: ["250"],
    languages: ["rw", "en", "fr"],
  },
  {
    name: "Saint Barthélemy",
    alpha2Code: "BL",
    callingCodes: ["590"],
    languages: ["fr"],
  },
  {
    name: "Saint Helena, Ascension and Tristan da Cunha",
    alpha2Code: "SH",
    callingCodes: ["290"],
    languages: ["en"],
  },
  {
    name: "Saint Kitts and Nevis",
    alpha2Code: "KN",
    callingCodes: ["1869"],
    languages: ["en"],
  },
  {
    name: "Saint Lucia",
    alpha2Code: "LC",
    callingCodes: ["1758"],
    languages: ["en"],
  },
  {
    name: "Saint Martin (French part)",
    alpha2Code: "MF",
    callingCodes: ["590"],
    languages: ["en", "fr", "nl"],
  },
  {
    name: "Saint Pierre and Miquelon",
    alpha2Code: "PM",
    callingCodes: ["508"],
    languages: ["fr"],
  },
  {
    name: "Saint Vincent and the Grenadines",
    alpha2Code: "VC",
    callingCodes: ["1784"],
    languages: ["en"],
  },
  {
    name: "Samoa",
    alpha2Code: "WS",
    callingCodes: ["685"],
    languages: ["sm", "en"],
  },
  {
    name: "San Marino",
    alpha2Code: "SM",
    callingCodes: ["378"],
    languages: ["it"],
  },
  {
    name: "Sao Tome and Principe",
    alpha2Code: "ST",
    callingCodes: ["239"],
    languages: ["pt"],
  },
  {
    name: "Saudi Arabia",
    alpha2Code: "SA",
    callingCodes: ["966"],
    languages: ["ar"],
  },
  {
    name: "Senegal",
    alpha2Code: "SN",
    callingCodes: ["221"],
    languages: ["fr"],
  },
  {
    name: "Serbia",
    alpha2Code: "RS",
    callingCodes: ["381"],
    languages: ["sr"],
  },
  {
    name: "Seychelles",
    alpha2Code: "SC",
    callingCodes: ["248"],
    languages: ["fr", "en"],
  },
  {
    name: "Sierra Leone",
    alpha2Code: "SL",
    callingCodes: ["232"],
    languages: ["en"],
  },
  {
    name: "Singapore",
    alpha2Code: "SG",
    callingCodes: ["65"],
    languages: ["en", "ms", "ta", "zh"],
  },
  {
    name: "Sint Maarten (Dutch part)",
    alpha2Code: "SX",
    callingCodes: ["1721"],
    languages: ["nl", "en"],
  },
  {
    name: "Slovakia",
    alpha2Code: "SK",
    callingCodes: ["421"],
    languages: ["sk"],
  },
  {
    name: "Slovenia",
    alpha2Code: "SI",
    callingCodes: ["386"],
    languages: ["sl"],
  },
  {
    name: "Solomon Islands",
    alpha2Code: "SB",
    callingCodes: ["677"],
    languages: ["en"],
  },
  {
    name: "Somalia",
    alpha2Code: "SO",
    callingCodes: ["252"],
    languages: ["so", "ar"],
  },
  {
    name: "South Africa",
    alpha2Code: "ZA",
    callingCodes: ["27"],
    languages: ["af", "en", "nr", "st", "ss", "tn", "ts", "ve", "xh", "zu"],
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    alpha2Code: "GS",
    callingCodes: ["500"],
    languages: ["en"],
  },
  {
    name: "Korea (Republic of)",
    alpha2Code: "KR",
    callingCodes: ["82"],
    languages: ["ko"],
  },
  {
    name: "South Sudan",
    alpha2Code: "SS",
    callingCodes: ["211"],
    languages: ["en"],
  },
  {
    name: "Spain",
    alpha2Code: "ES",
    callingCodes: ["34"],
    languages: ["es", "eu", "ca", "gl", "oc"],
  },
  {
    name: "Sri Lanka",
    alpha2Code: "LK",
    callingCodes: ["94"],
    languages: ["si", "ta"],
  },
  {
    name: "Sudan",
    alpha2Code: "SD",
    callingCodes: ["249"],
    languages: ["ar", "en"],
  },
  {
    name: "Suriname",
    alpha2Code: "SR",
    callingCodes: ["597"],
    languages: ["nl"],
  },
  {
    name: "Svalbard and Jan Mayen",
    alpha2Code: "SJ",
    callingCodes: ["4779"],
    languages: ["no"],
  },
  {
    name: "Swaziland",
    alpha2Code: "SZ",
    callingCodes: ["268"],
    languages: ["en", "ss"],
  },
  {
    name: "Sweden",
    alpha2Code: "SE",
    callingCodes: ["46"],
    languages: ["sv"],
  },
  {
    name: "Switzerland",
    alpha2Code: "CH",
    callingCodes: ["41"],
    languages: ["de", "fr", "it"],
  },
  {
    name: "Syrian Arab Republic",
    alpha2Code: "SY",
    callingCodes: ["963"],
    languages: ["ar"],
  },
  {
    name: "Taiwan",
    alpha2Code: "TW",
    callingCodes: ["886"],
    languages: ["zh"],
  },
  {
    name: "Tajikistan",
    alpha2Code: "TJ",
    callingCodes: ["992"],
    languages: ["tg", "ru"],
  },
  {
    name: "Tanzania, United Republic of",
    alpha2Code: "TZ",
    callingCodes: ["255"],
    languages: ["sw", "en"],
  },
  {
    name: "Timor-Leste",
    alpha2Code: "TL",
    callingCodes: ["670"],
    languages: ["pt"],
  },
  {
    name: "Togo",
    alpha2Code: "TG",
    callingCodes: ["228"],
    languages: ["fr"],
  },
  {
    name: "Tokelau",
    alpha2Code: "TK",
    callingCodes: ["690"],
    languages: ["en"],
  },
  {
    name: "Tonga",
    alpha2Code: "TO",
    callingCodes: ["676"],
    languages: ["en", "to"],
  },
  {
    name: "Trinidad and Tobago",
    alpha2Code: "TT",
    callingCodes: ["1868"],
    languages: ["en"],
  },
  {
    name: "Tunisia",
    alpha2Code: "TN",
    callingCodes: ["216"],
    languages: ["ar"],
  },
  {
    name: "Turkey",
    alpha2Code: "TR",
    callingCodes: ["90"],
    languages: ["tr"],
  },
  {
    name: "Turkmenistan",
    alpha2Code: "TM",
    callingCodes: ["993"],
    languages: ["tk", "ru"],
  },
  {
    name: "Turks and Caicos Islands",
    alpha2Code: "TC",
    callingCodes: ["1649"],
    languages: ["en"],
  },
  {
    name: "Tuvalu",
    alpha2Code: "TV",
    callingCodes: ["688"],
    languages: ["en"],
  },
  {
    name: "Uganda",
    alpha2Code: "UG",
    callingCodes: ["256"],
    languages: ["en", "sw"],
  },
  {
    name: "Ukraine",
    alpha2Code: "UA",
    callingCodes: ["380"],
    languages: ["uk"],
  },
  {
    name: "United Arab Emirates",
    alpha2Code: "AE",
    callingCodes: ["971"],
    languages: ["ar"],
  },
  {
    name: "United Kingdom of Great Britain and Northern Ireland",
    alpha2Code: "GB",
    callingCodes: ["44"],
    languages: ["en"],
  },
  {
    name: "United States of America",
    alpha2Code: "US",
    callingCodes: ["1"],
    languages: ["en"],
  },
  {
    name: "Uruguay",
    alpha2Code: "UY",
    callingCodes: ["598"],
    languages: ["es"],
  },
  {
    name: "Uzbekistan",
    alpha2Code: "UZ",
    callingCodes: ["998"],
    languages: ["uz", "ru"],
  },
  {
    name: "Vanuatu",
    alpha2Code: "VU",
    callingCodes: ["678"],
    languages: ["bi", "en", "fr"],
  },
  {
    name: "Venezuela (Bolivarian Republic of)",
    alpha2Code: "VE",
    callingCodes: ["58"],
    languages: ["es"],
  },
  {
    name: "Viet Nam",
    alpha2Code: "VN",
    callingCodes: ["84"],
    languages: ["vi"],
  },
  {
    name: "Wallis and Futuna",
    alpha2Code: "WF",
    callingCodes: ["681"],
    languages: ["fr"],
  },
  {
    name: "Western Sahara",
    alpha2Code: "EH",
    callingCodes: ["212"],
    languages: ["es"],
  },
  {
    name: "Yemen",
    alpha2Code: "YE",
    callingCodes: ["967"],
    languages: ["ar"],
  },
  {
    name: "Zambia",
    alpha2Code: "ZM",
    callingCodes: ["260"],
    languages: ["en"],
  },
  {
    name: "Zimbabwe",
    alpha2Code: "ZW",
    callingCodes: ["263"],
    languages: ["en", "sn", "nd"],
  },
];

export const CountryListConstMap = keyBy(CountryListConst, 'alpha2Code');

export class CountryType {
  public static readonly Afghanistan = new DisplayValueMap(
    "Common.Country.Afghanistan",
    "AF"
  );
  public static readonly AlandIslands = new DisplayValueMap(
    "Common.Country.AlandIslands",
    "AX"
  );
  public static readonly Albania = new DisplayValueMap(
    "Common.Country.Albania",
    "AL"
  );
  public static readonly Algeria = new DisplayValueMap(
    "Common.Country.Algeria",
    "DZ"
  );
  public static readonly AmericanSamoa = new DisplayValueMap(
    "Common.Country.AmericanSamoa",
    "AS"
  );
  public static readonly Andorra = new DisplayValueMap(
    "Common.Country.Andorra",
    "AD"
  );
  public static readonly Angola = new DisplayValueMap(
    "Common.Country.Angola",
    "AO"
  );
  public static readonly Anguilla = new DisplayValueMap(
    "Common.Country.Anguilla",
    "AI"
  );
  public static readonly Antarctica = new DisplayValueMap(
    "Common.Country.Antarctica",
    "AQ"
  );
  public static readonly AntiguaBarbuda = new DisplayValueMap(
    "Common.Country.AntiguaBarbuda",
    "AG"
  );
  public static readonly Argentina = new DisplayValueMap(
    "Common.Country.Argentina",
    "AR"
  );
  public static readonly Armenia = new DisplayValueMap(
    "Common.Country.Armenia",
    "AM"
  );
  public static readonly Aruba = new DisplayValueMap(
    "Common.Country.Aruba",
    "AW"
  );
  public static readonly Australia = new DisplayValueMap(
    "Common.Country.Australia",
    "AU"
  );
  public static readonly Austria = new DisplayValueMap(
    "Common.Country.Austria",
    "AT"
  );
  public static readonly Azerbaijan = new DisplayValueMap(
    "Common.Country.Azerbaijan",
    "AZ"
  );
  public static readonly Bahamas = new DisplayValueMap(
    "Common.Country.Bahamas",
    "BS"
  );
  public static readonly Bahrain = new DisplayValueMap(
    "Common.Country.Bahrain",
    "BH"
  );
  public static readonly Bangladesh = new DisplayValueMap(
    "Common.Country.Bangladesh",
    "BD"
  );
  public static readonly Barbados = new DisplayValueMap(
    "Common.Country.Barbados",
    "BB"
  );
  public static readonly Belarus = new DisplayValueMap(
    "Common.Country.Belarus",
    "BY"
  );
  public static readonly Belgium = new DisplayValueMap(
    "Common.Country.Belgium",
    "BE"
  );
  public static readonly Belize = new DisplayValueMap(
    "Common.Country.Belize",
    "BZ"
  );
  public static readonly Benin = new DisplayValueMap(
    "Common.Country.Benin",
    "BJ"
  );
  public static readonly Bermuda = new DisplayValueMap(
    "Common.Country.Bermuda",
    "BM"
  );
  public static readonly Bhutan = new DisplayValueMap(
    "Common.Country.Bhutan",
    "BT"
  );
  public static readonly Bolivia = new DisplayValueMap(
    "Common.Country.Bolivia",
    "BO"
  );
  public static readonly CaribbeanNetherlands = new DisplayValueMap(
    "Common.Country.CaribbeanNetherlands",
    "BQ"
  );
  public static readonly BosniaHerzegovina = new DisplayValueMap(
    "Common.Country.BosniaHerzegovina",
    "BA"
  );
  public static readonly Botswana = new DisplayValueMap(
    "Common.Country.Botswana",
    "BW"
  );
  public static readonly BouvetIsland = new DisplayValueMap(
    "Common.Country.BouvetIsland",
    "BV"
  );
  public static readonly Brazil = new DisplayValueMap(
    "Common.Country.Brazil",
    "BR"
  );
  public static readonly BritishIndianOceanTerritory = new DisplayValueMap(
    "Common.Country.BritishIndianOceanTerritory",
    "IO"
  );
  public static readonly Brunei = new DisplayValueMap(
    "Common.Country.Brunei",
    "BN"
  );
  public static readonly Bulgaria = new DisplayValueMap(
    "Common.Country.Bulgaria",
    "BG"
  );
  public static readonly BurkinaFaso = new DisplayValueMap(
    "Common.Country.BurkinaFaso",
    "BF"
  );
  public static readonly Burundi = new DisplayValueMap(
    "Common.Country.Burundi",
    "BI"
  );
  public static readonly CaboVerde = new DisplayValueMap(
    "Common.Country.CaboVerde",
    "CV"
  );
  public static readonly Cambodia = new DisplayValueMap(
    "Common.Country.Cambodia",
    "KH"
  );
  public static readonly Cameroon = new DisplayValueMap(
    "Common.Country.Cameroon",
    "CM"
  );
  public static readonly Canada = new DisplayValueMap(
    "Common.Country.Canada",
    "CA"
  );
  public static readonly CaymanIslands = new DisplayValueMap(
    "Common.Country.CaymanIslands",
    "KY"
  );
  public static readonly CentralAfricanRepublic = new DisplayValueMap(
    "Common.Country.CentralAfricanRepublic",
    "CF"
  );
  public static readonly Chad = new DisplayValueMap(
    "Common.Country.Chad",
    "TD"
  );
  public static readonly Chile = new DisplayValueMap(
    "Common.Country.Chile",
    "CL"
  );
  public static readonly China = new DisplayValueMap(
    "Common.Country.China",
    "CN"
  );
  public static readonly ChristmasIsland = new DisplayValueMap(
    "Common.Country.ChristmasIsland",
    "CX"
  );
  public static readonly CocosKeelingIslands = new DisplayValueMap(
    "Common.Country.CocosKeelingIslands",
    "CC"
  );
  public static readonly Colombia = new DisplayValueMap(
    "Common.Country.Colombia",
    "CO"
  );
  public static readonly Comoros = new DisplayValueMap(
    "Common.Country.Comoros",
    "KM"
  );
  public static readonly Congo = new DisplayValueMap(
    "Common.Country.Congo",
    "CG"
  );
  public static readonly DRCongo = new DisplayValueMap(
    "Common.Country.DRCongo",
    "CD"
  );
  public static readonly CookIslands = new DisplayValueMap(
    "Common.Country.CookIslands",
    "CK"
  );
  public static readonly CostaRica = new DisplayValueMap(
    "Common.Country.CostaRica",
    "CR"
  );
  public static readonly CotedIvoire = new DisplayValueMap(
    "Common.Country.CotedIvoire",
    "CI"
  );
  public static readonly Croatia = new DisplayValueMap(
    "Common.Country.Croatia",
    "HR"
  );
  public static readonly Cuba = new DisplayValueMap(
    "Common.Country.Cuba",
    "CU"
  );
  public static readonly Curacao = new DisplayValueMap(
    "Common.Country.Curacao",
    "CW"
  );
  public static readonly Cyprus = new DisplayValueMap(
    "Common.Country.Cyprus",
    "CY"
  );
  public static readonly Czechia = new DisplayValueMap(
    "Common.Country.Czechia",
    "CZ"
  );
  public static readonly Denmark = new DisplayValueMap(
    "Common.Country.Denmark",
    "DK"
  );
  public static readonly Djibouti = new DisplayValueMap(
    "Common.Country.Djibouti",
    "DJ"
  );
  public static readonly Dominica = new DisplayValueMap(
    "Common.Country.Dominica",
    "DM"
  );
  public static readonly DominicanRepublic = new DisplayValueMap(
    "Common.Country.DominicanRepublic",
    "DO"
  );
  public static readonly Ecuador = new DisplayValueMap(
    "Common.Country.Ecuador",
    "EC"
  );
  public static readonly Egypt = new DisplayValueMap(
    "Common.Country.Egypt",
    "EG"
  );
  public static readonly ElSalvador = new DisplayValueMap(
    "Common.Country.ElSalvador",
    "SV"
  );
  public static readonly EquatorialGuinea = new DisplayValueMap(
    "Common.Country.EquatorialGuinea",
    "GQ"
  );
  public static readonly Eritrea = new DisplayValueMap(
    "Common.Country.Eritrea",
    "ER"
  );
  public static readonly Estonia = new DisplayValueMap(
    "Common.Country.Estonia",
    "EE"
  );
  public static readonly Eswatini = new DisplayValueMap(
    "Common.Country.Eswatini",
    "SZ"
  );
  public static readonly Ethiopia = new DisplayValueMap(
    "Common.Country.Ethiopia",
    "ET"
  );
  public static readonly FalklandIslands = new DisplayValueMap(
    "Common.Country.FalklandIslands",
    "FK"
  );
  public static readonly FaroeIslands = new DisplayValueMap(
    "Common.Country.FaroeIslands",
    "FO"
  );
  public static readonly Fiji = new DisplayValueMap(
    "Common.Country.Fiji",
    "FJ"
  );
  public static readonly Finland = new DisplayValueMap(
    "Common.Country.Finland",
    "FI"
  );
  public static readonly France = new DisplayValueMap(
    "Common.Country.France",
    "FR"
  );
  public static readonly FrenchGuiana = new DisplayValueMap(
    "Common.Country.FrenchGuiana",
    "GF"
  );
  public static readonly FrenchPolynesia = new DisplayValueMap(
    "Common.Country.FrenchPolynesia",
    "PF"
  );
  public static readonly FrenchSouthernTerritories = new DisplayValueMap(
    "Common.Country.FrenchSouthernTerritories",
    "TF"
  );
  public static readonly Gabon = new DisplayValueMap(
    "Common.Country.Gabon",
    "GA"
  );
  public static readonly Gambia = new DisplayValueMap(
    "Common.Country.Gambia",
    "GM"
  );
  public static readonly Georgia = new DisplayValueMap(
    "Common.Country.Georgia",
    "GE"
  );
  public static readonly Germany = new DisplayValueMap(
    "Common.Country.Germany",
    "DE"
  );
  public static readonly Ghana = new DisplayValueMap(
    "Common.Country.Ghana",
    "GH"
  );
  public static readonly Gibraltar = new DisplayValueMap(
    "Common.Country.Gibraltar",
    "GI"
  );
  public static readonly Greece = new DisplayValueMap(
    "Common.Country.Greece",
    "GR"
  );
  public static readonly Greenland = new DisplayValueMap(
    "Common.Country.Greenland",
    "GL"
  );
  public static readonly Grenada = new DisplayValueMap(
    "Common.Country.Grenada",
    "GD"
  );
  public static readonly Guadeloupe = new DisplayValueMap(
    "Common.Country.Guadeloupe",
    "GP"
  );
  public static readonly Guam = new DisplayValueMap(
    "Common.Country.Guam",
    "GU"
  );
  public static readonly Guatemala = new DisplayValueMap(
    "Common.Country.Guatemala",
    "GT"
  );
  public static readonly Guernsey = new DisplayValueMap(
    "Common.Country.Guernsey",
    "GG"
  );
  public static readonly Guinea = new DisplayValueMap(
    "Common.Country.Guinea",
    "GN"
  );
  public static readonly GuineaBissau = new DisplayValueMap(
    "Common.Country.GuineaBissau",
    "GW"
  );
  public static readonly Guyana = new DisplayValueMap(
    "Common.Country.Guyana",
    "GY"
  );
  public static readonly Haiti = new DisplayValueMap(
    "Common.Country.Haiti",
    "HT"
  );
  public static readonly HeardMcDonaldIslands = new DisplayValueMap(
    "Common.Country.HeardMcDonaldIslands",
    "HM"
  );
  public static readonly VaticanCity = new DisplayValueMap(
    "Common.Country.VaticanCity",
    "VA"
  );
  public static readonly Honduras = new DisplayValueMap(
    "Common.Country.Honduras",
    "HN"
  );
  public static readonly HongKong = new DisplayValueMap(
    "Common.Country.HongKong",
    "HK"
  );
  public static readonly Hungary = new DisplayValueMap(
    "Common.Country.Hungary",
    "HU"
  );
  public static readonly Iceland = new DisplayValueMap(
    "Common.Country.Iceland",
    "IS"
  );
  public static readonly India = new DisplayValueMap(
    "Common.Country.India",
    "IN"
  );
  public static readonly Indonesia = new DisplayValueMap(
    "Common.Country.Indonesia",
    "ID"
  );
  public static readonly Iran = new DisplayValueMap(
    "Common.Country.Iran",
    "IR"
  );
  public static readonly Iraq = new DisplayValueMap(
    "Common.Country.Iraq",
    "IQ"
  );
  public static readonly Ireland = new DisplayValueMap(
    "Common.Country.Ireland",
    "IE"
  );
  public static readonly IsleofMan = new DisplayValueMap(
    "Common.Country.IsleofMan",
    "IM"
  );
  public static readonly Israel = new DisplayValueMap(
    "Common.Country.Israel",
    "IL"
  );
  public static readonly Italy = new DisplayValueMap(
    "Common.Country.Italy",
    "IT"
  );
  public static readonly Jamaica = new DisplayValueMap(
    "Common.Country.Jamaica",
    "JM"
  );
  public static readonly Japan = new DisplayValueMap(
    "Common.Country.Japan",
    "JP"
  );
  public static readonly Jersey = new DisplayValueMap(
    "Common.Country.Jersey",
    "JE"
  );
  public static readonly Jordan = new DisplayValueMap(
    "Common.Country.Jordan",
    "JO"
  );
  public static readonly Kazakhstan = new DisplayValueMap(
    "Common.Country.Kazakhstan",
    "KZ"
  );
  public static readonly Kenya = new DisplayValueMap(
    "Common.Country.Kenya",
    "KE"
  );
  public static readonly Kiribati = new DisplayValueMap(
    "Common.Country.Kiribati",
    "KI"
  );
  public static readonly NorthKorea = new DisplayValueMap(
    "Common.Country.NorthKorea",
    "KP"
  );
  public static readonly SouthKorea = new DisplayValueMap(
    "Common.Country.SouthKorea",
    "KR"
  );
  public static readonly Kuwait = new DisplayValueMap(
    "Common.Country.Kuwait",
    "KW"
  );
  public static readonly Kyrgyzstan = new DisplayValueMap(
    "Common.Country.Kyrgyzstan",
    "KG"
  );
  public static readonly Laos = new DisplayValueMap(
    "Common.Country.Laos",
    "LA"
  );
  public static readonly Latvia = new DisplayValueMap(
    "Common.Country.Latvia",
    "LV"
  );
  public static readonly Lebanon = new DisplayValueMap(
    "Common.Country.Lebanon",
    "LB"
  );
  public static readonly Lesotho = new DisplayValueMap(
    "Common.Country.Lesotho",
    "LS"
  );
  public static readonly Liberia = new DisplayValueMap(
    "Common.Country.Liberia",
    "LR"
  );
  public static readonly Libya = new DisplayValueMap(
    "Common.Country.Libya",
    "LY"
  );
  public static readonly Liechtenstein = new DisplayValueMap(
    "Common.Country.Liechtenstein",
    "LI"
  );
  public static readonly Lithuania = new DisplayValueMap(
    "Common.Country.Lithuania",
    "LT"
  );
  public static readonly Luxembourg = new DisplayValueMap(
    "Common.Country.Luxembourg",
    "LU"
  );
  public static readonly Macao = new DisplayValueMap(
    "Common.Country.Macao",
    "MO"
  );
  public static readonly Madagascar = new DisplayValueMap(
    "Common.Country.Madagascar",
    "MG"
  );
  public static readonly Malawi = new DisplayValueMap(
    "Common.Country.Malawi",
    "MW"
  );
  public static readonly Malaysia = new DisplayValueMap(
    "Common.Country.Malaysia",
    "MY"
  );
  public static readonly Maldives = new DisplayValueMap(
    "Common.Country.Maldives",
    "MV"
  );
  public static readonly Mali = new DisplayValueMap(
    "Common.Country.Mali",
    "ML"
  );
  public static readonly Malta = new DisplayValueMap(
    "Common.Country.Malta",
    "MT"
  );
  public static readonly MarshallIslands = new DisplayValueMap(
    "Common.Country.MarshallIslands",
    "MH"
  );
  public static readonly Martinique = new DisplayValueMap(
    "Common.Country.Martinique",
    "MQ"
  );
  public static readonly Mauritania = new DisplayValueMap(
    "Common.Country.Mauritania",
    "MR"
  );
  public static readonly Mauritius = new DisplayValueMap(
    "Common.Country.Mauritius",
    "MU"
  );
  public static readonly Mayotte = new DisplayValueMap(
    "Common.Country.Mayotte",
    "YT"
  );
  public static readonly Mexico = new DisplayValueMap(
    "Common.Country.Mexico",
    "MX"
  );
  public static readonly Micronesia = new DisplayValueMap(
    "Common.Country.Micronesia",
    "FM"
  );
  public static readonly Moldova = new DisplayValueMap(
    "Common.Country.Moldova",
    "MD"
  );
  public static readonly Monaco = new DisplayValueMap(
    "Common.Country.Monaco",
    "MC"
  );
  public static readonly Mongolia = new DisplayValueMap(
    "Common.Country.Mongolia",
    "MN"
  );
  public static readonly Montenegro = new DisplayValueMap(
    "Common.Country.Montenegro",
    "ME"
  );
  public static readonly Montserrat = new DisplayValueMap(
    "Common.Country.Montserrat",
    "MS"
  );
  public static readonly Morocco = new DisplayValueMap(
    "Common.Country.Morocco",
    "MA"
  );
  public static readonly Mozambique = new DisplayValueMap(
    "Common.Country.Mozambique",
    "MZ"
  );
  public static readonly Myanmar = new DisplayValueMap(
    "Common.Country.Myanmar",
    "MM"
  );
  public static readonly Namibia = new DisplayValueMap(
    "Common.Country.Namibia",
    "NA"
  );
  public static readonly Nauru = new DisplayValueMap(
    "Common.Country.Nauru",
    "NR"
  );
  public static readonly Nepal = new DisplayValueMap(
    "Common.Country.Nepal",
    "NP"
  );
  public static readonly Netherlands = new DisplayValueMap(
    "Common.Country.Netherlands",
    "NL"
  );
  public static readonly NewCaledonia = new DisplayValueMap(
    "Common.Country.NewCaledonia",
    "NC"
  );
  public static readonly NewZealand = new DisplayValueMap(
    "Common.Country.NewZealand",
    "NZ"
  );
  public static readonly Nicaragua = new DisplayValueMap(
    "Common.Country.Nicaragua",
    "NI"
  );
  public static readonly Niger = new DisplayValueMap(
    "Common.Country.Niger",
    "NE"
  );
  public static readonly Nigeria = new DisplayValueMap(
    "Common.Country.Nigeria",
    "NG"
  );
  public static readonly Niue = new DisplayValueMap(
    "Common.Country.Niue",
    "NU"
  );
  public static readonly NorfolkIsland = new DisplayValueMap(
    "Common.Country.NorfolkIsland",
    "NF"
  );
  public static readonly NorthMacedonia = new DisplayValueMap(
    "Common.Country.NorthMacedonia",
    "MK"
  );
  public static readonly NorthernMarianaIslands = new DisplayValueMap(
    "Common.Country.NorthernMarianaIslands",
    "MP"
  );
  public static readonly Norway = new DisplayValueMap(
    "Common.Country.Norway",
    "NO"
  );
  public static readonly Oman = new DisplayValueMap(
    "Common.Country.Oman",
    "OM"
  );
  public static readonly Pakistan = new DisplayValueMap(
    "Common.Country.Pakistan",
    "PK"
  );
  public static readonly Palau = new DisplayValueMap(
    "Common.Country.Palau",
    "PW"
  );
  public static readonly Palestine = new DisplayValueMap(
    "Common.Country.Palestine",
    "PS"
  );
  public static readonly Panama = new DisplayValueMap(
    "Common.Country.Panama",
    "PA"
  );
  public static readonly PapuaNewGuinea = new DisplayValueMap(
    "Common.Country.PapuaNewGuinea",
    "PG"
  );
  public static readonly Paraguay = new DisplayValueMap(
    "Common.Country.Paraguay",
    "PY"
  );
  public static readonly Peru = new DisplayValueMap(
    "Common.Country.Peru",
    "PE"
  );
  public static readonly Philippines = new DisplayValueMap(
    "Common.Country.Philippines",
    "PH"
  );
  public static readonly Pitcairn = new DisplayValueMap(
    "Common.Country.Pitcairn",
    "PN"
  );
  public static readonly Poland = new DisplayValueMap(
    "Common.Country.Poland",
    "PL"
  );
  public static readonly Portugal = new DisplayValueMap(
    "Common.Country.Portugal",
    "PT"
  );
  public static readonly PuertoRico = new DisplayValueMap(
    "Common.Country.PuertoRico",
    "PR"
  );
  public static readonly Qatar = new DisplayValueMap(
    "Common.Country.Qatar",
    "QA"
  );
  public static readonly Reunion = new DisplayValueMap(
    "Common.Country.Reunion",
    "RE"
  );
  public static readonly Romania = new DisplayValueMap(
    "Common.Country.Romania",
    "RO"
  );
  public static readonly Russia = new DisplayValueMap(
    "Common.Country.Russia",
    "RU"
  );
  public static readonly Rwanda = new DisplayValueMap(
    "Common.Country.Rwanda",
    "RW"
  );
  public static readonly StBarthelemy = new DisplayValueMap(
    "Common.Country.StBarthelemy",
    "BL"
  );
  public static readonly StHelena = new DisplayValueMap(
    "Common.Country.StHelena",
    "SH"
  );
  public static readonly StKittsNevis = new DisplayValueMap(
    "Common.Country.StKittsNevis",
    "KN"
  );
  public static readonly StLucia = new DisplayValueMap(
    "Common.Country.StLucia",
    "LC"
  );
  public static readonly StMartin = new DisplayValueMap(
    "Common.Country.StMartin",
    "MF"
  );
  public static readonly StPierreMiquelon = new DisplayValueMap(
    "Common.Country.StPierreMiquelon",
    "PM"
  );
  public static readonly StVincentGrenadines = new DisplayValueMap(
    "Common.Country.StVincentGrenadines",
    "VC"
  );
  public static readonly Samoa = new DisplayValueMap(
    "Common.Country.Samoa",
    "WS"
  );
  public static readonly SanMarino = new DisplayValueMap(
    "Common.Country.SanMarino",
    "SM"
  );
  public static readonly SaoTomePrincipe = new DisplayValueMap(
    "Common.Country.SaoTomePrincipe",
    "ST"
  );
  public static readonly SaudiArabia = new DisplayValueMap(
    "Common.Country.SaudiArabia",
    "SA"
  );
  public static readonly Senegal = new DisplayValueMap(
    "Common.Country.Senegal",
    "SN"
  );
  public static readonly Serbia = new DisplayValueMap(
    "Common.Country.Serbia",
    "RS"
  );
  public static readonly Seychelles = new DisplayValueMap(
    "Common.Country.Seychelles",
    "SC"
  );
  public static readonly SierraLeone = new DisplayValueMap(
    "Common.Country.SierraLeone",
    "SL"
  );
  public static readonly Singapore = new DisplayValueMap(
    "Common.Country.Singapore",
    "SG"
  );
  public static readonly SintMaarten = new DisplayValueMap(
    "Common.Country.SintMaarten",
    "SX"
  );
  public static readonly Slovakia = new DisplayValueMap(
    "Common.Country.Slovakia",
    "SK"
  );
  public static readonly Slovenia = new DisplayValueMap(
    "Common.Country.Slovenia",
    "SI"
  );
  public static readonly SolomonIslands = new DisplayValueMap(
    "Common.Country.SolomonIslands",
    "SB"
  );
  public static readonly Somalia = new DisplayValueMap(
    "Common.Country.Somalia",
    "SO"
  );
  public static readonly SouthAfrica = new DisplayValueMap(
    "Common.Country.SouthAfrica",
    "ZA"
  );
  public static readonly SoGeorgiaSoSandwichIsl = new DisplayValueMap(
    "Common.Country.SoGeorgiaSoSandwichIsl",
    "GS"
  );
  public static readonly SouthSudan = new DisplayValueMap(
    "Common.Country.SouthSudan",
    "SS"
  );
  public static readonly Spain = new DisplayValueMap(
    "Common.Country.Spain",
    "ES"
  );
  public static readonly SriLanka = new DisplayValueMap(
    "Common.Country.SriLanka",
    "LK"
  );
  public static readonly Sudan = new DisplayValueMap(
    "Common.Country.Sudan",
    "SD"
  );
  public static readonly Suriname = new DisplayValueMap(
    "Common.Country.Suriname",
    "SR"
  );
  public static readonly SvalbardJanMayen = new DisplayValueMap(
    "Common.Country.SvalbardJanMayen",
    "SJ"
  );
  public static readonly Sweden = new DisplayValueMap(
    "Common.Country.Sweden",
    "SE"
  );
  public static readonly Switzerland = new DisplayValueMap(
    "Common.Country.Switzerland",
    "CH"
  );
  public static readonly Syria = new DisplayValueMap(
    "Common.Country.Syria",
    "SY"
  );
  public static readonly Taiwan = new DisplayValueMap(
    "Common.Country.Taiwan",
    "TW"
  );
  public static readonly Tajikistan = new DisplayValueMap(
    "Common.Country.Tajikistan",
    "TJ"
  );
  public static readonly Tanzania = new DisplayValueMap(
    "Common.Country.Tanzania",
    "TZ"
  );
  public static readonly Thailand = new DisplayValueMap(
    "Common.Country.Thailand",
    "TH"
  );
  public static readonly TimorLeste = new DisplayValueMap(
    "Common.Country.TimorLeste",
    "TL"
  );
  public static readonly Togo = new DisplayValueMap(
    "Common.Country.Togo",
    "TG"
  );
  public static readonly Tokelau = new DisplayValueMap(
    "Common.Country.Tokelau",
    "TK"
  );
  public static readonly Tonga = new DisplayValueMap(
    "Common.Country.Tonga",
    "TO"
  );
  public static readonly TrinidadTobago = new DisplayValueMap(
    "Common.Country.TrinidadTobago",
    "TT"
  );
  public static readonly Tunisia = new DisplayValueMap(
    "Common.Country.Tunisia",
    "TN"
  );
  public static readonly Turkey = new DisplayValueMap(
    "Common.Country.Turkey",
    "TR"
  );
  public static readonly Turkmenistan = new DisplayValueMap(
    "Common.Country.Turkmenistan",
    "TM"
  );
  public static readonly TurksCaicosIslands = new DisplayValueMap(
    "Common.Country.TurksCaicosIslands",
    "TC"
  );
  public static readonly Tuvalu = new DisplayValueMap(
    "Common.Country.Tuvalu",
    "TV"
  );
  public static readonly Uganda = new DisplayValueMap(
    "Common.Country.Uganda",
    "UG"
  );
  public static readonly Ukraine = new DisplayValueMap(
    "Common.Country.Ukraine",
    "UA"
  );
  public static readonly UnitedArabEmirates = new DisplayValueMap(
    "Common.Country.UnitedArabEmirates",
    "AE"
  );
  public static readonly UnitedKingdom = new DisplayValueMap(
    "Common.Country.UnitedKingdom",
    "GB"
  );
  public static readonly USMinorOutlyingIslands = new DisplayValueMap(
    "Common.Country.USMinorOutlyingIslands",
    "UM"
  );
  public static readonly UnitedStates = new DisplayValueMap(
    "Common.Country.UnitedStates",
    "US"
  );
  public static readonly Uruguay = new DisplayValueMap(
    "Common.Country.Uruguay",
    "UY"
  );
  public static readonly Uzbekistan = new DisplayValueMap(
    "Common.Country.Uzbekistan",
    "UZ"
  );
  public static readonly Vanuatu = new DisplayValueMap(
    "Common.Country.Vanuatu",
    "VU"
  );
  public static readonly Venezuela = new DisplayValueMap(
    "Common.Country.Venezuela",
    "VE"
  );
  public static readonly Vietnam = new DisplayValueMap(
    "Common.Country.Vietnam",
    "VN"
  );
  public static readonly BritishVirginIslands = new DisplayValueMap(
    "Common.Country.BritishVirginIslands",
    "VG"
  );
  public static readonly USVirginIslands = new DisplayValueMap(
    "Common.Country.USVirginIslands",
    "VI"
  );
  public static readonly WallisFutuna = new DisplayValueMap(
    "Common.Country.WallisFutuna",
    "WF"
  );
  public static readonly WesternSahara = new DisplayValueMap(
    "Common.Country.WesternSahara",
    "EH"
  );
  public static readonly Yemen = new DisplayValueMap(
    "Common.Country.Yemen",
    "YE"
  );
  public static readonly Zambia = new DisplayValueMap(
    "Common.Country.Zambia",
    "ZM"
  );
  public static readonly Zimbabwe = new DisplayValueMap(
    "Common.Country.Zimbabwe",
    "ZW"
  );

  public static readonly countries = [
    CountryType.Afghanistan,
    CountryType.AlandIslands,
    CountryType.Albania,
    CountryType.Algeria,
    CountryType.AmericanSamoa,
    CountryType.Andorra,
    CountryType.Angola,
    CountryType.Anguilla,
    CountryType.Antarctica,
    CountryType.AntiguaBarbuda,
    CountryType.Argentina,
    CountryType.Armenia,
    CountryType.Aruba,
    CountryType.Australia,
    CountryType.Austria,
    CountryType.Azerbaijan,
    CountryType.Bahamas,
    CountryType.Bahrain,
    CountryType.Bangladesh,
    CountryType.Barbados,
    CountryType.Belarus,
    CountryType.Belgium,
    CountryType.Belize,
    CountryType.Benin,
    CountryType.Bermuda,
    CountryType.Bhutan,
    CountryType.Bolivia,
    CountryType.CaribbeanNetherlands,
    CountryType.BosniaHerzegovina,
    CountryType.Botswana,
    CountryType.BouvetIsland,
    CountryType.Brazil,
    CountryType.BritishIndianOceanTerritory,
    CountryType.Brunei,
    CountryType.Bulgaria,
    CountryType.BurkinaFaso,
    CountryType.Burundi,
    CountryType.CaboVerde,
    CountryType.Cambodia,
    CountryType.Cameroon,
    CountryType.Canada,
    CountryType.CaymanIslands,
    CountryType.CentralAfricanRepublic,
    CountryType.Chad,
    CountryType.Chile,
    CountryType.China,
    CountryType.ChristmasIsland,
    CountryType.CocosKeelingIslands,
    CountryType.Colombia,
    CountryType.Comoros,
    CountryType.Congo,
    CountryType.DRCongo,
    CountryType.CookIslands,
    CountryType.CostaRica,
    CountryType.CotedIvoire,
    CountryType.Croatia,
    CountryType.Cuba,
    CountryType.Curacao,
    CountryType.Cyprus,
    CountryType.Czechia,
    CountryType.Denmark,
    CountryType.Djibouti,
    CountryType.Dominica,
    CountryType.DominicanRepublic,
    CountryType.Ecuador,
    CountryType.Egypt,
    CountryType.ElSalvador,
    CountryType.EquatorialGuinea,
    CountryType.Eritrea,
    CountryType.Estonia,
    CountryType.Eswatini,
    CountryType.Ethiopia,
    CountryType.FalklandIslands,
    CountryType.FaroeIslands,
    CountryType.Fiji,
    CountryType.Finland,
    CountryType.France,
    CountryType.FrenchGuiana,
    CountryType.FrenchPolynesia,
    CountryType.FrenchSouthernTerritories,
    CountryType.Gabon,
    CountryType.Gambia,
    CountryType.Georgia,
    CountryType.Germany,
    CountryType.Ghana,
    CountryType.Gibraltar,
    CountryType.Greece,
    CountryType.Greenland,
    CountryType.Grenada,
    CountryType.Guadeloupe,
    CountryType.Guam,
    CountryType.Guatemala,
    CountryType.Guernsey,
    CountryType.Guinea,
    CountryType.GuineaBissau,
    CountryType.Guyana,
    CountryType.Haiti,
    CountryType.HeardMcDonaldIslands,
    CountryType.VaticanCity,
    CountryType.Honduras,
    CountryType.HongKong,
    CountryType.Hungary,
    CountryType.Iceland,
    CountryType.India,
    CountryType.Indonesia,
    CountryType.Iran,
    CountryType.Iraq,
    CountryType.Ireland,
    CountryType.IsleofMan,
    CountryType.Israel,
    CountryType.Italy,
    CountryType.Jamaica,
    CountryType.Japan,
    CountryType.Jersey,
    CountryType.Jordan,
    CountryType.Kazakhstan,
    CountryType.Kenya,
    CountryType.Kiribati,
    CountryType.NorthKorea,
    CountryType.SouthKorea,
    CountryType.Kuwait,
    CountryType.Kyrgyzstan,
    CountryType.Laos,
    CountryType.Latvia,
    CountryType.Lebanon,
    CountryType.Lesotho,
    CountryType.Liberia,
    CountryType.Libya,
    CountryType.Liechtenstein,
    CountryType.Lithuania,
    CountryType.Luxembourg,
    CountryType.Macao,
    CountryType.Madagascar,
    CountryType.Malawi,
    CountryType.Malaysia,
    CountryType.Maldives,
    CountryType.Mali,
    CountryType.Malta,
    CountryType.MarshallIslands,
    CountryType.Martinique,
    CountryType.Mauritania,
    CountryType.Mauritius,
    CountryType.Mayotte,
    CountryType.Mexico,
    CountryType.Micronesia,
    CountryType.Moldova,
    CountryType.Monaco,
    CountryType.Mongolia,
    CountryType.Montenegro,
    CountryType.Montserrat,
    CountryType.Morocco,
    CountryType.Mozambique,
    CountryType.Myanmar,
    CountryType.Namibia,
    CountryType.Nauru,
    CountryType.Nepal,
    CountryType.Netherlands,
    CountryType.NewCaledonia,
    CountryType.NewZealand,
    CountryType.Nicaragua,
    CountryType.Niger,
    CountryType.Nigeria,
    CountryType.Niue,
    CountryType.NorfolkIsland,
    CountryType.NorthMacedonia,
    CountryType.NorthernMarianaIslands,
    CountryType.Norway,
    CountryType.Oman,
    CountryType.Pakistan,
    CountryType.Palau,
    CountryType.Palestine,
    CountryType.Panama,
    CountryType.PapuaNewGuinea,
    CountryType.Paraguay,
    CountryType.Peru,
    CountryType.Philippines,
    CountryType.Pitcairn,
    CountryType.Poland,
    CountryType.Portugal,
    CountryType.PuertoRico,
    CountryType.Qatar,
    CountryType.Reunion,
    CountryType.Romania,
    CountryType.Russia,
    CountryType.Rwanda,
    CountryType.StBarthelemy,
    CountryType.StHelena,
    CountryType.StKittsNevis,
    CountryType.StLucia,
    CountryType.StMartin,
    CountryType.StPierreMiquelon,
    CountryType.StVincentGrenadines,
    CountryType.Samoa,
    CountryType.SanMarino,
    CountryType.SaoTomePrincipe,
    CountryType.SaudiArabia,
    CountryType.Senegal,
    CountryType.Serbia,
    CountryType.Seychelles,
    CountryType.SierraLeone,
    CountryType.Singapore,
    CountryType.SintMaarten,
    CountryType.Slovakia,
    CountryType.Slovenia,
    CountryType.SolomonIslands,
    CountryType.Somalia,
    CountryType.SouthAfrica,
    CountryType.SoGeorgiaSoSandwichIsl,
    CountryType.SouthSudan,
    CountryType.Spain,
    CountryType.SriLanka,
    CountryType.Sudan,
    CountryType.Suriname,
    CountryType.SvalbardJanMayen,
    CountryType.Sweden,
    CountryType.Switzerland,
    CountryType.Syria,
    CountryType.Taiwan,
    CountryType.Tajikistan,
    CountryType.Tanzania,
    CountryType.Thailand,
    CountryType.TimorLeste,
    CountryType.Togo,
    CountryType.Tokelau,
    CountryType.Tonga,
    CountryType.TrinidadTobago,
    CountryType.Tunisia,
    CountryType.Turkey,
    CountryType.Turkmenistan,
    CountryType.TurksCaicosIslands,
    CountryType.Tuvalu,
    CountryType.Uganda,
    CountryType.Ukraine,
    CountryType.UnitedArabEmirates,
    CountryType.UnitedKingdom,
    CountryType.USMinorOutlyingIslands,
    CountryType.UnitedStates,
    CountryType.Uruguay,
    CountryType.Uzbekistan,
    CountryType.Vanuatu,
    CountryType.Venezuela,
    CountryType.Vietnam,
    CountryType.BritishVirginIslands,
    CountryType.USVirginIslands,
    CountryType.WallisFutuna,
    CountryType.WesternSahara,
    CountryType.Yemen,
    CountryType.Zambia,
    CountryType.Zimbabwe,
  ];

  public static findType(countryCode: string) {
    let country = undefined;
    CountryType.countries.forEach((c) => {
      if (c.value === countryCode) {
        country = c;
      }
    });

    return country;
  }

  public static transformCountryCodes(countryCodes: string[]) {
    return CountryType.countries.filter((c) => countryCodes.includes(c.value));
  }
}
